"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
const regex_1 = require("../utils/regex");
exports.propTypes = {
    borderBottomLeftRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]),
    borderBottomRightRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]),
    borderRadius: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    borderTopLeftRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]),
    borderTopRightRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ])
};
exports.propAliases = {
    borderRadius: [
        'borderBottomLeftRadius',
        'borderBottomRightRadius',
        'borderTopLeftRadius',
        'borderTopRightRadius'
    ]
};
exports.propValidators = {};
if (process.env.NODE_ENV !== 'production') {
    exports.propValidators.borderRadius = value => {
        if (regex_1.spacesOutsideParentheses.test(value)) {
            return `multiple values (“${value}”) aren՚t supported with “borderRadius”. Use “borderBottomLeftRadius”, “borderBottomRightRadius” “borderTopLeftRadius” and “borderTopRightRadius” instead.`;
        }
        return;
    };
}
const borderTopLeftRadius = {
    className: 'btlr',
    cssName: 'border-top-left-radius',
    jsName: 'borderTopLeftRadius'
};
const borderTopRightRadius = {
    className: 'btrr',
    cssName: 'border-top-right-radius',
    jsName: 'borderTopRightRadius'
};
const borderBottomLeftRadius = {
    className: 'bblr',
    cssName: 'border-bottom-left-radius',
    jsName: 'borderBottomLeftRadius'
};
const borderBottomRightRadius = {
    className: 'bbrr',
    cssName: 'border-bottom-right-radius',
    jsName: 'borderBottomRightRadius'
};
exports.propEnhancers = {
    borderBottomLeftRadius: (value) => get_css_1.default(borderBottomLeftRadius, value),
    borderBottomRightRadius: (value) => get_css_1.default(borderBottomRightRadius, value),
    borderTopLeftRadius: (value) => get_css_1.default(borderTopLeftRadius, value),
    borderTopRightRadius: (value) => get_css_1.default(borderTopRightRadius, value)
};
//# sourceMappingURL=data:application/json;base64,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